export function getLabelFromArrayByParameter (value, array, parameter, label = 'label') {
  return array.find(item => item[parameter] === value)[label]
}

export function getLabelFromArrayByParametersList (value, array, parametersList, label = 'label') {
  return array.find(item => parametersList.every(param => item[param] === value[param]))[label]
}
